import styled from "styled-components";

const Container = ({children,borderBottom}) => {
    const ContainerWrapper = styled.div`
    padding: 0 30px;
    border-bottom: ${borderBottom ? "1px solid #dadce0" : "none"}
`;
    return (
        <ContainerWrapper borderBottom>{children}</ContainerWrapper>
    )
}

export default Container;